<template>
  <button
    class="action-btn mb-0"
    :class="getClasses(variant, color, size, fullWidth, active)"
  >
    <slot />
  </button>
</template>

<script>
export default {
  name: "SoftButton",
  props: {
    color: {
      type: String,
      default: "success",
    },
    size: {
      type: String,
      default: "md",
    },
    variant: {
      type: String,
      default: "fill",
    },
    fullWidth: {
      type: Boolean,
      default: false,
    },
    active: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    getClasses: (variant, color, size, fullWidth, active) => {
      const colorMap = {
        secondary: "muted",
        primary: "info",
      };
      const mappedColor = colorMap[color] || color;
      const sizeValue = size === "sm" ? "action-btn--compact" : size === "md" ? "action-btn--md" : null;
      const fullWidthValue = fullWidth ? "action-btn--block" : null;
      const activeValue = active ? "active" : null;

      return [
        `action-btn--${mappedColor}`,
        sizeValue,
        fullWidthValue,
        activeValue,
      ]
        .filter(Boolean)
        .join(" ");
    },
  },
};
</script>
